import type { HTMLAttributes } from 'react';
import React from 'react';

type Props = {
  label?: string;
  symbol: string;
} & HTMLAttributes<HTMLSpanElement>;

export const Emoji = ({ label, symbol, ...props }: Props) => {
  return (
    <span
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role="img"
      {...props}
    >
      {symbol}
    </span>
  );
};
